import React from "react";

const PricingMinusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <rect x="0.5" y="0.5" width="17" height="17" rx="3" stroke="#C8CDD8" />
    <path d="M5.5 9H12.5" stroke="#0E0E0E" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default PricingMinusIcon;
